<div class="relative flex h-full flex-col pt-3" *transloco="let t">
  <app-breadcrumb-item appNavBreadcrumb [title]="organization()?.organizationName ?? ''" />
  <IDataTable [datasource]="dataSource">
    <div iDataTablePrefix>
      <app-compact-filter [filters]="availableFilters()" (filterChange)="onFilterChange($event)" />
    </div>
    <div class="flex items-center gap-2" iDataTableSuffix>
      @if (canEditAccounts()) {
        <a iButton variant="secondary" [routerLink]="['account-linking']" [queryParams]="{ orgId: organization()?.id }">
          <IIcon name="add" />
          {{ t("account-setting.add_account") }}
        </a>
        <button iButton iDataTableSuffix variant="secondary" (click)="openEditDefaultCampaignLabelModal()">
          <IIcon name="tag" />
          {{ t("account-setting.edit_default_campaign_label") }}
        </button>
      }
    </div>

    <table iTable class="w-full">
      <thead iTableHead class="sticky top-0 left-0 z-50 border-none">
        <tr>
          <th iTableTh>
            <div class="flex items-center gap-2">
              @if (!isReadOnly() && dataSource.dataLength() > 0) {
                <ICheckbox [value]="isAllSelected()" (valueChange)="toggleSelectAllProducts()" class="mr-1.5" />
              }
              {{ t("activity-service.account") }}
              <IBadge [label]="dataSource.dataLength() + ' '" color="gray" size="xs" class="ml-1" />
            </div>
          </th>
          <th iTableTh>{{ t("common.marketplace") }}</th>
          <th iTableTh>{{ t("account-setting.account_group") }}</th>
          <th iTableTh>{{ t("common.status") }}</th>
          <th iTableTh>{{ t("account-setting.type") }}</th>
          <th iTableTh></th>
          <th iTableTh></th>
          <th iTableTh></th>
        </tr>
      </thead>
      <tbody>
        @for (accountMarketplace of dataSource.data(); track accountMarketplace.profileId) {
          <tr
            iTableRow
            app-account-list-row
            [accountMarketplace]="accountMarketplace"
            [organization]="organization()!"
            [adminOrganizationIds]="adminOrganizationIds()"
            [isRowSelected]="selectedProfileIds().has(accountMarketplace.profileId!)"
            (isRowSelectedChange)="onRowCheckboxClicked(accountMarketplace.profileId!)"
            class="group"
            [ngClass]="{ 'bg-main-50 hover:!bg-main-50': selectedProfileIds().has(accountMarketplace.profileId!) }"
          ></tr>
        }
      </tbody>
    </table>
  </IDataTable>

  <app-catalog-toolbar [display]="selectedRowsCount() > 0">
    <ng-template>
      <div class="flex items-center gap-3.5">
        <div class="flex items-baseline gap-1">
          <IBadge [label]="selectedRowsCount().toString()" size="xs" />
          <span class="text-xs text-gray-600">selected</span>
        </div>
        <button
          [iDropdownMenuTrigger]="moveAccountsMenu"
          iButton
          variant="secondary"
          placement="top-center"
          [disabled]="!canEditAccounts()"
        >
          {{ t("common.move") }}
          <IIcon name="chevronUp" class="text-gray-400" />
        </button>

        <ng-template #moveAccountsMenu>
          <IDropdownMenu>
            <div class="max-w-[300px] px-2 py-1 text-xs text-gray-400">
              {{ t("account-setting.account_settings_insctructions") }}
            </div>
            <IDropdownMenuSeparator />
            @if (eligibleTargetAccountGroups().length > 0) {
              @for (group of eligibleTargetAccountGroups(); track group.id) {
                <button iDropdownMenuItem [value]="group.id" (click)="moveSelectedAccountsToGroup(group)">
                  {{ group.name }}
                </button>
              }
              <IDropdownMenuSeparator />
            }
            <button
              iDropdownMenuItem
              (click)="moveToNewAccountGroup()"
              [disabled]="!canCreateNewAccountGroup()"
              [iTooltip]="!canCreateNewAccountGroup() ? t('account-setting.account_settings_insctructions') : undefined"
              iTooltipPlacement="left-center"
              iTooltipWidth="250"
            >
              <IIcon name="add" />
              {{ t("add-account-group.new_account_group") }}
            </button>
          </IDropdownMenu>
        </ng-template>

        <button
          iButton
          variant="destructive"
          (click)="deleteSelectedAccounts()"
          [loading]="deleteSelectedAccountsLoading()"
          [disabled]="!canDeleteSelectedAccounts()"
        >
          <IIcon name="trash" />
          {{ t("common.delete") }}
        </button>

        <button
          iButton
          variant="ghost"
          [iTooltip]="'Clear selection'"
          iTooltipPlacement="top-center"
          (click)="clearSelection()"
        >
          <IIcon name="close" />
        </button>
      </div>
    </ng-template>
  </app-catalog-toolbar>
</div>
